<template>
  <slot v-if="show" />
  <slot v-if="!show" name="preview" />
</template>

<script setup lang="ts">
const props = defineProps({
  delay: {
    type: Number,
    default: 100
  }
})

const show = ref(false)
setTimeout(() => {
  show.value = true
}, props.delay)
</script>

<style scoped>
:slotted(.fade-in) {
  animation: fadeIn 0.5s linear;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
